import { Grid } from "@mui/material";

import {
  RRDCouponGrid,
  RRDExpirationText,
  RRDImageSlot,
  RRDPageLabel,
} from "./RRDTemplateSlots";
import { couponSlots } from "./rrdLayoutSlotHelpers";
import type { RRDLayoutProps } from "./layoutTypes";

function ValueSheetInsertLayout(props: RRDLayoutProps) {
  const {
    layoutSpec,
    heroImages,
    coupons,
    frontExpirationDate,
    backExpirationDate,
    mode,
  } = props;
  const frontHeroSlot = layoutSpec.slots?.find(
    (slot) => slot.id === "hero_front"
  );
  const backHeroSlot = layoutSpec.slots?.find(
    (slot) => slot.id === "hero_back"
  );

  return (
    <>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Front</RRDPageLabel>
        <RRDImageSlot
          {...props}
          slot={frontHeroSlot}
          placeholder="Hero Image"
        />
        <RRDCouponGrid
          slots={couponSlots(layoutSpec, "front")}
          layoutSpec={layoutSpec}
          heroImages={heroImages}
          coupons={coupons}
          mode={mode}
          onOpenMobileSlot={props.onOpenMobileSlot}
          onRemoveAsset={props.onRemoveAsset}
          readOnly={props.readOnly}
        />
        <RRDExpirationText>{frontExpirationDate}</RRDExpirationText>
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Back</RRDPageLabel>
        <RRDCouponGrid
          slots={couponSlots(layoutSpec, "back", false)}
          layoutSpec={layoutSpec}
          heroImages={heroImages}
          coupons={coupons}
          mode={mode}
          readOnly
        />
        <RRDImageSlot {...props} slot={backHeroSlot} placeholder="Hero Image" />
        <RRDExpirationText>{backExpirationDate}</RRDExpirationText>
      </Grid>
    </>
  );
}

export default ValueSheetInsertLayout;
